import { styled } from '../../../utils/styled'
import type { CSSObject } from '../../theme/themeTypes'
import { Tabs } from '@mui/material'
import { ICON_TAB_CLASS_NAME } from '../IconTab/classnames'
import { type TabsSize } from './types'

export const StyledTabs = styled(Tabs)<{ size?: TabsSize }>(
  ({ theme, size }): CSSObject => ({
    minHeight: 'unset',
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .MuiTab-root.Mui-selected': {
      [`&.${ICON_TAB_CLASS_NAME}`]: {
        color: theme.tokens.foreground.semantic.info.default
      },
      color: theme.tokens.foreground.main.primary,
      background: theme.tokens.background.tonal.soft.default
    },
    '& .MuiTab-root:hover': {
      background: theme.tokens.background.main.pressed
    },
    '& .MuiTabs-flexContainer': {
      gap: size === 'small' ? '8px' : '24px'
    }
  })
)
